<template>
  <div id="contenedor-contrato-video">
    <v-card>
      <v-card-title class="secondary--text">
          Reproducir video
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-row justify="center">
          <!-- <iframe
            width="700"
            height="400"
            src="https://www.youtube.com/embed/wk_PKHlHDDo?si=WoRG70W9JudZVm7o"
            frameborder="0"
            allowfullscreen
          >
          </iframe> -->
          <!-- <iframe
            width="700"
            height="400"
            :src="urlYoutube"
            frameborder="0"
            allowfullscreen>
          </iframe> -->
          <embed type="video/webm" :src="urlYoutube" width="700" height="400">
          <!-- <object width="700" height="400"
          :data="urlYoutube">
          </object> -->
        </v-row>
        <v-card-actions>
          <v-row justify="center">
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cerrar"
              class="mr-3">
            </custom-button>
          </v-row>
        </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoVideo.vue',
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      urlYoutube: this.video.url,

    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>

</style>
